/** @module csi/breadcrumb/StatusRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Renderer",
	"csi/locale",
	"csi/reflectionHints"
], function(declare,Renderer,locale,reflectionHints) {

	return declare(Renderer, {
		/**
		 * Render status node
		 * @param {Object} ctx
		 * @param {Object} h
		 * @param {DomNode} refNode
		 */
		headingToHtml: function(ctx, h, refNode) {
			var node = ctx.getNode();
			
			// for favorites node get the favorite item node
			if (node.__FavoriteItem__) {
				node = ctx.cache.getNode(node.__FavoriteItem__);
			}
			
			var status = reflectionHints.getLocationNodeStatus(node, true);
			if (status) {
				$(refNode).html(locale.resource(status)).addClass("csi-card-pill csi-name-value-status");
			}
		}
	});
})